<template>
  <div>
    <head-nav-bar title="联房" :fixed="true" />
    <div class="mt-header-nav ">
      <van-search
        placeholder="房号/入住人/订单号"
        style="border-bottom:1px solid #f1f1f1;"
        show-action
        shape="round"
        v-model="keyword"
        @search="onSearch"
      >
        <div slot="action" @click="onSearch">搜索</div>
      </van-search>
      <van-tabs
        v-model="activeTab"
        @change="getRoomNos"
        title-active-color="#098ae8"
      >
        <van-tab title="在住单" name="1" />
        <van-tab title="预订单" name="0" />
      </van-tabs>
      <div class="checkgroup-box" v-if="orderList.length">
        <div v-for="item in orderList" :key="item.OrderId" class="order-item">
          <p class="g-title">
            订单号：<span @click="checkOrder(item.OrderId)">{{
              item.OrderNo
            }}</span>
          </p>
          <van-checkbox
            v-for="room in item.AppointRoomInfos"
            :key="room.GuestId"
            :disabled="item.disabled"
            v-model="room.checked"
            shape="square"
            @change="changeRoom($event, room)"
            class="check-item"
          >
            <span class="room-no"> {{ room.RoomNo }}</span>
            <span class="guest-info">
              <span> 客人：{{ room.GuestName }}</span>
              <span>
                住离：{{ room.CheckInDate }}至{{ room.CheckOutDate }}</span
              >
            </span>
          </van-checkbox>
        </div>
      </div>
      <div style="margin:30px 0;text-align:center;font-size:18px;" v-else>
        暂无数据！
      </div>
      <van-goods-action v-if="orderList.length">
        <template slot="default">
          <van-row style="width:100%">
            <van-col span="12">
              <van-button size="large" @click="onCancel">
                取消
              </van-button>
            </van-col>

            <van-col span="12">
              <van-button type="info" size="large" @click="onSubmit">
                保存
              </van-button>
            </van-col>
          </van-row>
        </template>
      </van-goods-action>
    </div>
  </div>
</template>

<script>
import orderApi from "../../api/order.js";
import {
  Row,
  Col,
  Checkbox,
  CheckboxGroup,
  GoodsAction,
  Button,
  Notify,
  Search,
  Tab,
  Tabs,
  Dialog,
} from "vant";
export default {
  name: "UnitRoom",
  components: {
    [Row.name]: Row,
    [Col.name]: Col,
    [CheckboxGroup.name]: CheckboxGroup,
    [Checkbox.name]: Checkbox,
    [GoodsAction.name]: GoodsAction,
    [Button.name]: Button,
    [Notify.name]: Notify,
    [Search.name]: Search,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
  },
  data() {
    return {
      orderId: "",
      orderList: [],
      checkList: [],
      keyword: "",
      activeTab: "1",
    };
  },
  created() {
    this.orderId = this.$route.query.id;
    this.keyword = "";
    this.getRoomNos();
  },
  methods: {
    onSearch() {
      this.getRoomNos();
    },
    getRoomNos() {
      this.orderList = [];
      orderApi
        .getRoomNos({
          FilteOrderIds: [this.orderId],
          Keyword: this.keyword,
          OrderStatus: this.activeTab,
        })
        .then(res => {
          if (res.Data.length) {
            this.orderList = res.Data.map(v => {
              if (v.AppointRoomInfos && v.AppointRoomInfos.length) {
                v.AppointRoomInfos = v.AppointRoomInfos.map(el => {
                  el.TargetOrderId = v.OrderId;
                  return el;
                });
              }
              return v;
            });
          }
        });
    },
    checkOrder(Id) {
      this.$router.push({ name: "OrderDetail", query: { id: Id } });
    },
    onCancel() {
      //  this.checkList = [];
      // this.orderList = this.orderList.map(v => {
      //   v.disabled = false;
      //   if (v.CheckInRoomInfos && v.CheckInRoomInfos.length) {
      //      v.CheckInRoomInfos.forEach(el => {
      //       el.checked = false;
      //     });
      //   }
      //   return v;
      // });
      this.$router.push({ name: "OrderDetail", query: { id: this.orderId } });
    },
    onSubmit() {
      if (!this.checkList.length) {
        Notify("请选择联房的房号");
        return false;
      }
      let params = {
        SourceRoomInfoIds: this.checkList,
        TargetOrderId: this.orderId,
      };
      const _this = this;
      Dialog.confirm({
        title: "确定联房操作吗？",
      }).then(() => {
        orderApi.unitRoom(params).then(res => {
          Dialog.alert({
            message: res.Message,
          }).then(() => {
            _this.$router.push({
              name: "OrderDetail",
              query: { id: this.orderId },
            });
          });
        });
      });
    },
    changeRoom(checked, room) {
      room.checked = checked;
      const targetOrderId = room.TargetOrderId;
      const targetOrder = this.orderList.find(
        ele => ele.OrderId == targetOrderId,
      );
      this.checkList = [];
      const hasChecked = targetOrder.AppointRoomInfos.some(el => el.checked);
      targetOrder.AppointRoomInfos.forEach(el => {
        if (el.checked) {
          this.checkList.push(el.RoomInfoId);
        }
      });
      this.orderList = this.orderList.map(v => {
        if ((v.OrderId == targetOrderId && hasChecked) || !hasChecked) {
          v.disabled = false;
        } else {
          v.disabled = true;
        }
        return v;
      });
    },
  },
};
</script>

<style lang="less" scoped>
.checkgroup-box {
  margin-top: 10px;
  width: 100%;
  .g-title {
    background: #f5f5f5;
    padding: 5px 15px;
    color: #333;
    margin-bottom: 5px;
    span {
      font-size: 16px;
      color: #0084fe;
      text-decoration: underline;
      cursor: pointer;
    }
  }
  .van-checkbox {
    padding-left: 16px;
    margin: 5px 0;
    /deep/.van-checkbox__label {
      width: 100%;
      border-bottom: 1px dashed #e8e8e8;
      padding-bottom: 3px;
    }
  }
  .order-item {
    margin-top: 20px;
    &:first-child {
      margin-top: 0;
    }
    .check-item:last-child {
      /deep/.van-checkbox__label {
        border-bottom: 0;
        padding-bottom: 0;
      }
    }
  }
  .check-item {
    padding-right: 8px;
    .room-no {
      display: inline-block;
      height: 40px;
      line-height: 40px;
      left: 40px;
    }
    .guest-info {
      float: right;
      span {
        display: block;
        font-size: 12px;
        color: #999;
      }
    }
  }
}
/deep/.van-tab--active:after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 10%;
  z-index: 1;
  height: 3px;
  width: 80%;
  background-color: #ee0a24;
}
/deep/.van-tabs__line {
  display: none;
}
</style>
